import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Menu from '@mui/material/Menu'
import Typography from '@mui/material/Typography'
import IconButton from '@mui/material/IconButton'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import SearchIcon from '@mui/icons-material/Search'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import Checkbox from '@mui/material/Checkbox'
import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import classNames from 'classnames'
import _ from 'lodash'

import styles from './MenuUnidades.module.css'
import {
  atualizarFiltros,
  descartarFiltrosSelecionadosMenuFiltros
} from '../../../actions/filtrosActions'
import { salvarResponsabilidade } from '../../../util/applicationContext'
import {
  atualizarUnidadesAtuais,
  temUnidadesAtuaisSelecionadas,
  getUnidadesAtuaisLabelAbrev,
  getUnidadesSuperioresAtuais,
  atualizarTodasUnidadesAtuais,
  getUnidadesSorted,
  isSameUnidade
} from '../../../controllers/unidadesController'
import MenuSubunidades from './MenuSubunidades'
import {
  OPCAO_RESP_POR_AGIR,
  OPCAO_RESP_TECNICA,
  OPCAO_RESP_TECNICA_NAO_RESP_AGIR
} from '../../../reducers/filtrosReducer'
import MenuFiltrosItemsRadioGroup from '../filtros/MenuFiltrosItemsRadioGroup'

class MenuUnidades extends Component {
  constructor(props) {
    super(props)
    this.state = {
      unidadesMenuAnchorEl: null,
      filtrarPor: ''
    }
    this.handleUnidadesMenuOpen = this.handleUnidadesMenuOpen.bind(this)
    this.handleUnidadesMenuClose = this.handleUnidadesMenuClose.bind(this)
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this)
    this.handleFiltrarPorChange = this.handleFiltrarPorChange.bind(this)
  }

  redirect() {
    const {
      history,
      history: {
        location: { pathname }
      }
    } = this.props
    if (pathname !== '/') {
      history.push('/')
    }
  }

  handleUnidadesMenuOpen(event) {
    this.setState({ unidadesMenuAnchorEl: event.currentTarget })
  }

  handleUnidadesMenuClose() {
    this.setState({ unidadesMenuAnchorEl: null })
  }

  handleMarcarDesmarcarTodosButtonClick(marcarTodos) {
    this.props.descartarFiltrosSelecionadosMenuFiltros()
    const {
      filtros: { responsabilidadeUnidade },
      unidadesUsuario: { unidades }
    } = this.props
    let unidadesAtuais = marcarTodos
      ? atualizarTodasUnidadesAtuais(unidades)
      : atualizarTodasUnidadesAtuais({})
    if (
      _.size(unidadesAtuais) > 1 &&
      responsabilidadeUnidade === OPCAO_RESP_TECNICA_NAO_RESP_AGIR
    ) {
      this.props.atualizarFiltros({
        unidadesAtuais,
        todasUnidadesDesmarcadas: !marcarTodos,
        responsabilidadeUnidade: OPCAO_RESP_POR_AGIR
      })
    } else {
      this.props.atualizarFiltros({ unidadesAtuais, todasUnidadesDesmarcadas: !marcarTodos })
    }
    this.setState({ filtrarPor: '' })
    this.redirect()
  }

  handleCheckboxClick(unidade, checked) {
    this.props.descartarFiltrosSelecionadosMenuFiltros()
    const {
      filtros: { unidadesAtuais: prevUnidadesAtuais, responsabilidadeUnidade },
      unidadesUsuario: { unidades }
    } = this.props
    const unidadesAtuais = atualizarUnidadesAtuais(unidade, checked, prevUnidadesAtuais, unidades)
    if (
      _.size(unidadesAtuais) > 1 &&
      responsabilidadeUnidade === OPCAO_RESP_TECNICA_NAO_RESP_AGIR
    ) {
      this.props.atualizarFiltros({
        gruposTipo: [],
        unidadesAtuais,
        todasUnidadesDesmarcadas: !_.size(unidadesAtuais),
        responsabilidadeUnidade: OPCAO_RESP_POR_AGIR
      })
    } else {
      this.props.atualizarFiltros({
        gruposTipo: [],
        unidadesAtuais,
        todasUnidadesDesmarcadas: !_.size(unidadesAtuais)
      })
    }
    this.setState({ filtrarPor: '' })
    this.redirect()
  }

  handleFiltrarPorChange(event) {
    this.setState({ filtrarPor: event.target.value })
  }

  renderRespPorAgirGrid() {
    const {
      filtros: { unidadesAtuais }
    } = this.props
    let radioGroupOptions = {
      [OPCAO_RESP_POR_AGIR]: OPCAO_RESP_POR_AGIR,
      [OPCAO_RESP_TECNICA]: OPCAO_RESP_TECNICA,
      [OPCAO_RESP_TECNICA_NAO_RESP_AGIR]: OPCAO_RESP_TECNICA_NAO_RESP_AGIR
    }
    if (_.size(unidadesAtuais) > 1) {
      radioGroupOptions = _.omit(radioGroupOptions, [OPCAO_RESP_TECNICA_NAO_RESP_AGIR])
    }
    return (
      <MenuFiltrosItemsRadioGroup
        expanded
        noExpandIcon
        radioGroupRow
        defaultExpanded
        itemKey='responsabilidadeUnidade'
        label='Responsabilidade'
        setMenuItemHandle={salvarResponsabilidade}
        radioGroupOptions={radioGroupOptions}
        classes={{ containerGrid: styles.containerGrid }}
      />
    )
  }

  renderUnidadesAtuaisIconMenu(unidadesMenuId) {
    const {
      filtros: { unidadesAtuais, responsabilidadeUnidade },
      unidadesUsuario: { unidades }
    } = this.props
    const { unidadesMenuAnchorEl } = this.state
    return (
      <Grid item>
        <Typography
          variant='h6'
          color='primary'
          id='unidade-atual-title'
          className={styles.unidadesMenu}
          aria-owns={unidadesMenuAnchorEl ? unidadesMenuId : null}
          aria-haspopup='true'
          onClick={this.handleUnidadesMenuOpen}>
          {temUnidadesAtuaisSelecionadas(unidadesAtuais)
            ? getUnidadesAtuaisLabelAbrev(unidadesAtuais, unidades)
            : 'Selecione a Unidade Técnica'}
          <IconButton
            aria-owns={unidadesMenuAnchorEl ? unidadesMenuId : null}
            aria-haspopup='true'
            color='primary'
            style={{ padding: 0 }}
            className={styles.toolbarItem}
            id='unidades-menu-button'
            onClick={this.handleUnidadesMenuOpen}>
            <ArrowDropDown />
          </IconButton>
        </Typography>
        <Typography variant='caption' id='responsabilidade-title' color='textSecondary'>
          Resp.: <b>{responsabilidadeUnidade}</b>
        </Typography>
      </Grid>
    )
  }

  renderUnidadesMenuHeader() {
    const {
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidades }
    } = this.props
    const { filtrarPor } = this.state
    const unidadesSuperioresAtuais = getUnidadesSuperioresAtuais(unidadesAtuais, unidades)
    const todosChecked =
      temUnidadesAtuaisSelecionadas(unidadesAtuais) &&
      _.size(unidadesSuperioresAtuais) === _.size(unidades)
    return (
      <React.Fragment>
        <Grid item sm={5}>
          <Typography variant='h5' color='primary'>
            Unidades técnicas
          </Typography>
          <Typography
            variant='subtitle1'
            color={!temUnidadesAtuaisSelecionadas(unidadesAtuais) ? 'error' : 'textSecondary'}>
            Selecione as unidades técnicas
          </Typography>
        </Grid>
        {_.size(unidades) > 1 ? (
          <React.Fragment>
            <Grid container item sm={7}>
              {this.renderRespPorAgirGrid()}
            </Grid>
            <Grid container style={{ marginBottom: 24 }}>
              <Grid container item sm={5} justifyContent='space-evenly' alignItems='flex-end'>
                <Button
                  id='menu-unidades-button-marcar-todos'
                  variant='outlined'
                  size='small'
                  color='primary'
                  disabled={todosChecked}
                  onClick={() => this.handleMarcarDesmarcarTodosButtonClick(true)}>
                  Marcar todos
                </Button>
                <Button
                  id='menu-unidades-button-desmarcar-todos'
                  size='small'
                  color='primary'
                  style={{ marginRight: 8 }}
                  disabled={!temUnidadesAtuaisSelecionadas(unidadesAtuais)}
                  onClick={() => this.handleMarcarDesmarcarTodosButtonClick(false)}>
                  Desmarcar todos
                </Button>
              </Grid>
              <Grid item sm={7}>
                <TextField
                  onKeyDown={(event) => event.stopPropagation()}
                  id='filtrarPorUnidades'
                  type='search'
                  className={styles.filtrarPorTextField}
                  label={
                    <div style={{ alignItems: 'center', display: 'flex' }}>
                      <SearchIcon style={{ height: 18 }} />
                      Pesquisar
                    </div>
                  }
                  value={filtrarPor}
                  onChange={this.handleFiltrarPorChange}
                />
              </Grid>
            </Grid>
          </React.Fragment>
        ) : (
          <Grid item xs={7} container style={{ padding: 0 }}>
            {this.renderRespPorAgirGrid()}
          </Grid>
        )}
      </React.Fragment>
    )
  }

  renderUnidadesMenu() {
    const {
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidades, unidadeVinculacaoHierarquica }
    } = this.props
    const { filtrarPor } = this.state
    const unidadesFiltered = _.filter(unidades, (unidade) =>
      _.toUpper(unidade.nomeReduzido).includes(_.toUpper(filtrarPor))
    )
    const unidadesOrdenadas = getUnidadesSorted(unidadesFiltered, unidadeVinculacaoHierarquica)
    const unidadesSuperioresAtuais = _.keyBy(
      getUnidadesSuperioresAtuais(unidadesAtuais, unidades),
      (unidade) => unidade.codigoUnidade
    )
    const disabled = _.size(unidades) === 1
    const exibirSubunidades = _.size(getUnidadesSuperioresAtuais(unidadesAtuais, unidades)) === 1
    return (
      <React.Fragment>
        {this.renderUnidadesMenuHeader()}
        <Grid item xs={exibirSubunidades ? 8 : 12} container alignContent='flex-start'>
          {_.values(unidadesOrdenadas).map((unidade, index) => (
            <Grid item xs={6} sm={4} key={_.uniqueId('grid-unidade-')}>
              <FormControlLabel
                id={`unidade-${unidade.sigla.toUpperCase()}`}
                control={
                  <Checkbox
                    key={_.uniqueId('unidade-')}
                    disabled={disabled}
                    color='primary'
                    value={unidade.codigoUnidade.toString()}
                    checked={Boolean(unidadesSuperioresAtuais[unidade.codigoUnidade])}
                    onChange={(event) => this.handleCheckboxClick(unidade, event.target.checked)}
                  />
                }
                label={_.truncate(_.toUpper(unidade.nomeReduzido), { length: 15 })}
                classes={{
                  disabled: styles.unidadesDisabledLabel,
                  root: isSameUnidade(unidade, unidadeVinculacaoHierarquica)
                    ? styles.unidadesUsuarioLogado
                    : ''
                }}
              />
            </Grid>
          ))}
        </Grid>
      </React.Fragment>
    )
  }

  renderSubunidadesMenu() {
    const {
      filtros: { unidadesAtuais },
      unidadesUsuario: { unidades }
    } = this.props
    const exibirSubunidades = _.size(getUnidadesSuperioresAtuais(unidadesAtuais, unidades)) === 1
    return exibirSubunidades ? (
      <Grid item xs={4} container className={styles.menuSubunidade}>
        <MenuSubunidades handleCheckboxClick={this.handleCheckboxClick} />
      </Grid>
    ) : null
  }

  renderMenu(unidadesMenuId) {
    const { unidadesMenuAnchorEl } = this.state
    return (
      <Menu
        elevation={16}
        id={unidadesMenuId}
        anchorEl={unidadesMenuAnchorEl}
        open={Boolean(unidadesMenuAnchorEl)}
        MenuListProps={{ component: 'div' }}
        onClose={this.handleUnidadesMenuClose}>
        <Grid
          container
          spacing={2}
          className={classNames(styles.modalUnidades, styles.unidadesMenuItems)}>
          {this.renderUnidadesMenu()}
          {this.renderSubunidadesMenu()}
        </Grid>
      </Menu>
    )
  }

  render() {
    const { hideMenuUnidades } = this.props
    if (hideMenuUnidades) return <div id='menu-unidades-oculto' />
    const {
      unidadesUsuario: { unidades }
    } = this.props
    const unidadesMenuId = 'unidadesMenuId'
    return _.size(unidades) ? (
      <React.Fragment>
        {this.renderUnidadesAtuaisIconMenu(unidadesMenuId)}
        {this.renderMenu(unidadesMenuId)}
      </React.Fragment>
    ) : (
      <div id='usuario-sem-visao-unidades' />
    )
  }
}

const mapStateToProps = ({ filtros, unidadesUsuario }) => ({ filtros, unidadesUsuario })

const reduxEnhanced = connect(mapStateToProps, {
  atualizarFiltros,
  descartarFiltrosSelecionadosMenuFiltros
})(MenuUnidades)

export default withRouter(reduxEnhanced)
